module.exports = __webpack_public_path__ + "static/img/s2model1.17a90b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model1.png
// module id = OA6W
// module chunks = 0